import React, { useState } from 'react';
import { useAppSelector, useAppDispatch } from '../store/hooks';
import { selectModalOnboarding, selectModalPractice } from '../store/onboardingSlice';
import { updateProductType } from '../store/onboardingSlice';
import { ViewStageHistory } from './OnboardingViewHelpers';

const OverviewModal = () => {
  const dispatch = useAppDispatch();
  const modalOnboarding = useAppSelector(selectModalOnboarding);
  const modalPractice = useAppSelector(selectModalPractice);
  
  const [selectedProductType, setSelectedProductType] = useState(modalOnboarding?.productType || '');
  const [isSaving, setIsSaving] = useState(false);

  const productTypeOptions = [
    'voip',
    'non-voip',
    'dso'
  ];

  const handleSaveProductType = async () => {
    if (!modalOnboarding?.id || !selectedProductType) {
      return;
    }

    setIsSaving(true);
    try {
      await dispatch(updateProductType({
        id: modalOnboarding.id,
        productType: selectedProductType
      })).unwrap();
      console.log('Product type updated successfully');
    } catch (error) {
      console.error('Failed to update product type:', error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="space-y-4">
      
      { modalOnboarding &&  (
        <>
          {/* Name field */}
          <table>
            <tbody>
            <tr>
              <td>Practice Name</td>
              <td>{modalPractice?.name}</td>
            </tr>
            <tr>
              <td>Practice Address</td>
              <td>{modalPractice?.address}</td>
            </tr>
            <tr>
              <td>Product Type</td>
              <td>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <select
                    value={selectedProductType}
                    onChange={(e) => setSelectedProductType(e.target.value)}
                    style={{
                      padding: '4px 8px',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      fontSize: '14px'
                    }}
                  >
                    <option value="">Select Product</option>
                    {productTypeOptions.map(option => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                  <button
                    onClick={handleSaveProductType}
                    disabled={isSaving || !selectedProductType}
                    style={{
                      padding: '4px 12px',
                      backgroundColor: selectedProductType && !isSaving ? '#007bff' : '#6c757d',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: selectedProductType && !isSaving ? 'pointer' : 'not-allowed',
                      fontSize: '14px'
                    }}
                  >
                    {isSaving ? 'Saving...' : 'Save'}
                  </button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>

          
          {/* Stage History */}
          <ViewStageHistory 
            onboarding={modalOnboarding} 
            stage="overview" 
          />
        </>
      )}
    </div>
  );
};

export { OverviewModal };
